import type { BoardRow, DraftRow, PlacementDecision } from './types'

/** What the row shows: the unsaved edit, else the saved placement, else nothing decided. */
export function effectiveRow(row: BoardRow, draft: DraftRow | undefined): DraftRow {
  if (draft) return draft
  const p = row.placement
  if (p && p.status !== 'cancelled')
    return {
      decision: p.decision,
      targetClassId: p.targetClass?.id ?? null,
      targetSectionId: p.targetSection?.id ?? null,
      note: p.note,
    }
  return { decision: '', targetClassId: null, targetSectionId: null, note: null }
}

export const needsPlace = (d: PlacementDecision | '') => d === 'promote' || d === 'repeat'
